import { render } from "./ReferencesSwiper.vue?vue&type=template&id=bfc9ce4c&lang=pug"
import script from "./ReferencesSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferencesSwiper.vue?vue&type=script&setup=true&lang=js"

import "./ReferencesSwiper.vue?vue&type=style&index=0&id=bfc9ce4c&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__